var _circle, _path, _circle2, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInvite2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 56,
  height: 56,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 16,
  r: 12,
  fill: "url(#paint0_linear_128_4942)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M45 50C47.2091 50 49.0449 48.1858 48.5379 46.0357C47.6983 42.4754 45.7381 39.1787 42.8492 36.565C38.911 33.0018 33.5695 31 28 31C22.4305 31 17.089 33.0018 13.1508 36.565C10.262 39.1787 8.3017 42.4754 7.46212 46.0357C6.95506 48.1858 8.79086 50 11 50L28 50H45Z",
  fill: "url(#paint1_linear_128_4942)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 40,
  r: 12,
  fill: "url(#paint2_linear_128_4942)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M40.9951 35L40.9951 45",
  stroke: "white",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M46 39.995L36 39.995",
  stroke: "white",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_128_4942",
  x1: 16,
  y1: 4,
  x2: 34.2961,
  y2: 27.3692,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D2C6FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E1D9FE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_128_4942",
  x1: 7,
  y1: 31,
  x2: 16.3909,
  y2: 57.5147,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D2C6FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E1D9FE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_128_4942",
  x1: 31.2,
  y1: 28,
  x2: 49.6071,
  y2: 64.2504,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7856F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2CF1FF"
})))));
export default SvgInvite2;